'use client';

import { Button } from '@/components/ui/common/button';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import AnimateInOut from '@/components/ui/common/gsap/AnimateInOut';
import useContactUsContext from '@/components/providers/context/contact-us-context';
import { useLocale } from '@/components/providers/context/locale-context';

function ContactUs() {
    const { t } = useTranslation('contact-us');
    const { openForm } = useContactUsContext();
    const contactUsRef = useRef<HTMLDivElement>(null);

    return (
        <section
            id="contact-us"
            ref={contactUsRef}
            style={{ height: 'var(--simulaix-vh, 100svh)' }}
            className="relative flex w-full flex-col items-center justify-center gap-[12px]"
        >
            <AnimateInOut
                durationIn={0.5}
                durationOut={0.5}
                delay={0}
                delayOut={0}
                from={{
                    opacity: 1,
                    width: '100%',
                    height: '100%',
                }}
                to={{
                    opacity: 0,
                }}
                skipOutro={false}
                start="center center"
                end="bottom top"
                scrub
                watch
            >
                <div className="relative flex h-full w-full flex-col items-center justify-center px-[28px] sm:px-[96px]">
                    <h1 className={clsx(`j-h1 text-center text-white`)}>
                        <span>{t('title.part1')}</span>
                        <span>{t('title.part2')}</span>
                        <span>{t('title.part3')}</span>
                    </h1>
                    <div
                        className={clsx(
                            `j-h5 mb-[28px] text-center text-white`,
                        )}
                    >
                        {t('subtitle')}
                    </div>
                    <Button
                        className={clsx(
                            'j-t1 flex flex-row justify-between gap-[18px]',
                        )}
                        onClick={openForm}
                        text={t('button')}
                        icon={
                            <svg
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                width={18}
                                height={18}
                                fill="#FFFFFF"
                            >
                                <path d="M526.08 106.24l-60.586667 60.586667L768 469.333333H92.586667v85.333334H768l-302.506667 302.506666 60.586667 60.586667 405.333333-405.76z"></path>
                            </svg>
                        }
                    ></Button>

                    <div
                        className={clsx(
                            'j-p1 absolute bottom-[23px] right-[32px] text-[#C8C8C8]',
                        )}
                    >
                        {t('comment')}
                    </div>
                </div>
            </AnimateInOut>
        </section>
    );
}

export default ContactUs;
